<template>

  <v-app>
    <!-- Theme circle -->
    <ThemeCircle/>
     <bar ref="bar"/>
    <!-- Header -->
    <Header/>

    <v-main :style="{'margin-left': isSidebarVisible() ? '56px' : '0'}">

      <AppAlert class="mx-16 my-6" v-if="alert" :alert="alert"/>

      <!-- Views rendering go here -->
      <router-view/>

    </v-main>

    <!-- Sidebar -->
    <Sidebar v-if="isSidebarVisible()" :user="loggedUser"/>

    <!-- Footer -->
    <Footer  />

  </v-app>

</template>

<script>
  import { mapGetters } from 'vuex';
  import { AppConfigApi } from './shared/services/api/app-config'
  import Bar from './shared/components/SnackBar'

  export default {
    name: "App",
    components: { Bar },
    methods: {
      isSidebarVisible () {
        return this.loggedUser && !['/home', '/available-cars', '/booking'].includes(this.$router.history.current.path);
      },
      isHeaderVisible () {
        return ['/home', '/available-cars'].includes(this.$router.history.current.path);
      },
      isFooterVisible () {
        return !['/booking'].includes(this.$router.history.current.path);
      }
    },
    computed: {
      ...mapGetters({
        loggedUser: 'main/loggedUser',
        alert: 'main/alert'
      })
    },
    created: function () {
    },
    mounted() {
      this.$root.bar = this.$refs.bar
    },
  }
</script>


<style>
  body,
  html {
    background: #f1f8ff;
  }

  /*.app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    padding-top: 10px;
    min-height: 100vh !important;
    /*background-color: #0067b4;*/
  /*}*/
  /** Header */
  /*.v-sheet.theme--light.v-toolbar.v-toolbar--flat.v-app-bar{
    margin-bottom: 2rem !important;
   }*/
  .loggedInHeader .namee.v-btn.v-btn--icon.v-btn--round.theme--light.v-size--default {
    padding-bottom: 1.5rem;
  }

  .app-name {
    font-size: 4rem;
  }


  @media (max-width: 880px) {
    .app-name {
      font-size: 2rem;
    }
  }

  @media (min-width: 960px) {
    .padding-if-big-screen {
      padding: 0 20rem;
    }
  }
</style>
